import script from "./IssuesBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./IssuesBlock.vue?vue&type=script&setup=true&lang=ts"

import "./IssuesBlock.vue?vue&type=style&index=0&id=9410cd7c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9410cd7c"]])

export default __exports__